module.exports = __webpack_public_path__ + "static/img/09.bc1a7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/09.png
// module id = 9u2j
// module chunks = 1